import menu from '@/api/menu'
import user from '@/api/user'
export default {
  data() {
    return {
      dataSource: [{}],
      length: [
        {
          select: ''
        }
      ],
      authorityIds: []
    }
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route: {
      handler() {
        this.id = this.$route.params.id
        this.getMenus()
      },
      immediate: true
    }
  },
  methods: {
    async getMenus() {
      this.$set(this.dataSource, 0, await menu.get())
      this.authorityIds = await user.authority(this.id)
    },
    openChildren(index, val) {
      if (
        this.dataSource[index][val].children &&
        this.dataSource[index][val].children.length
      ) {
        this.$set(
          this.dataSource,
          index + 1,
          this.dataSource[index][val].children
        )
        this.$set(this.length, index, {
          select: val
        })
        this.$set(this.length, index + 1, {
          select: ''
        })
        this.length.splice(index + 2)
      }
    }
  }
}
